import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { IStateService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.libraryprocedures, {
    url: '/sops',
    params: { title: 'Library -  SOPs' },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'APP_CONFIG',
          '$state',
          'procedureApiService',
          function (
            APP_CONFIG: SharedAngular.APP_CONFIG,
            $state: IStateService,
            procedureApiService: SharedAngular.ProcedureApiService
          ) {
            if (!APP_CONFIG.enableProcedures) {
              $state.go(STATE_MAPPINGS.library);
              return;
            }
            if (!procedureApiService.proceduresLoaded) {
              procedureApiService.getProcedures();
              if (APP_CONFIG.enableTagging) {
                procedureApiService.getUsedTagsInProcedures();
              }
            }
          }
        ],
        template:
          '<runner-library-tabs></runner-library-tabs>' +
          '<library-procedures-grid></library-procedures-grid>'
      }
    }
  });
}
